import { IStudentRow } from 'types';
import { IOption } from 'shared-components';
import { UserRole } from '@/store/auth/types';
import { getManagePasswordOptions } from './resendResetPassword';
import { IUser } from '@/types';
import { getAssignVisaSupportOptions } from './assignVisaSupport';
import { getEditServicesDropDownOption } from './editServices';
import { getScheduledInterviewsOptions } from './scheduledInterviews';
import { getImmigrationProvidersDropDownOptions } from './editImmigrationProviders';
import { getResetMfaOptions } from './resetMfa';

export const getDropdownOptions = (
  userRole: UserRole,
  visibleStudents: IStudentRow[],
  selectedRows: string[],
  studentUserRecord: IUser | null,
  manualVisaSupportEnabled: boolean,
  isCalendlyEnabled: boolean,
  isRecordedInterviewEnabled: boolean,
  isPathwayProvider: boolean,
  hasPartners: boolean,
  immigrationProviders: boolean,
  isAddAndCancelInterviewVisible: boolean,
  areAllSelectedStudentsPathwaysEqual: boolean,
  allStudentsSelected: boolean,
  isOnlyPathwayStudents: boolean,
): Array<{ options: IOption[]; label?: string }> => [
  {
    options: [
      ...getManagePasswordOptions(userRole, studentUserRecord),
      ...getResetMfaOptions(userRole, studentUserRecord),
      ...getScheduledInterviewsOptions(
        userRole,
        isCalendlyEnabled,
        isRecordedInterviewEnabled,
        isPathwayProvider,
        selectedRows,
        visibleStudents,
        isAddAndCancelInterviewVisible,
        allStudentsSelected,
      ),
      ...getAssignVisaSupportOptions(
        userRole,
        manualVisaSupportEnabled,
        isPathwayProvider,
        selectedRows,
        visibleStudents,
      ),
    ],
  },
  {
    label: 'Edit providers for...',
    options: getOptions(
      hasPartners,
      immigrationProviders,
      userRole,
      areAllSelectedStudentsPathwaysEqual,
      isOnlyPathwayStudents,
    ),
  },
];

const getOptions = (
  hasPartners: boolean,
  immigrationProviders: boolean,
  userRole: UserRole,
  areAllSelectedStudentsPathwaysEqual: boolean,
  isOnlyPathwayStudents: boolean,
) => {
  if (hasPartners && immigrationProviders) {
    return [
      ...getEditServicesDropDownOption(userRole, areAllSelectedStudentsPathwaysEqual, isOnlyPathwayStudents),
      ...getImmigrationProvidersDropDownOptions(userRole),
    ];
  }
  if (hasPartners) {
    return [...getEditServicesDropDownOption(userRole, areAllSelectedStudentsPathwaysEqual, isOnlyPathwayStudents)];
  }
  if (immigrationProviders) {
    return [...getImmigrationProvidersDropDownOptions(userRole)];
  }
  return [];
};
